<template>
  <div :class="['replyMessageContainer', { merchantMessage: message.sent_by_merchant }]">
    <div>
      <div :class="['sender', 'text-truncate', { merchantMessage: message.sent_by_merchant }]">
        {{ message.sent_by_merchant ? $t('You') : message.profile_name ?? '' }}
      </div>
      <div class="textMessage text-truncate" v-if="message.type == MessageTypes.Text && !message.linker_payment_status">
        {{ message.content }}
      </div>
      <div class="paymentMessage text-truncate"
        v-else-if="message.type == MessageTypes.Text && !!message.linker_payment_status">
        {{ $t(message.linker_payment_status == PaymentStatuses.success ? 'Payment Succeeded' : 'Payment Failed') }}
      </div>
      <div class="orderText text-truncate" v-else-if="message.type == MessageTypes.Order">
        <img height="16" width="16" :src="loadFile(images.cart)">
        {{ $t('OrderReplyMessage') }} {{ message.linker_order_id }}
      </div>
      <div class="imageText text-truncate" v-else-if="message.type == MessageTypes.Image">
        <img height="16" width="16" :src="loadFile(images.camera)">
        {{ $t('Image') }}
      </div>
      <div class="imageText text-truncate" v-else-if="message.type == MessageTypes.Video">
        <i class="bi bi-camera-video me-2"></i>
        {{ $t('Video') }}
      </div>
      <div class="audioText text-truncate" v-else-if="message.type == MessageTypes.Audio">
        <img height="16" width="16" :src="loadFile(images.microphone)">
        {{ message?.content?.audio?.duration }}
      </div>
      <div class="imageText text-truncate" v-else-if="message.type == MessageTypes.Document">
        <i class="bi bi-file-earmark-text me-2"></i>
        {{ $t("file") }}
      </div>
      <div class="imageText text-truncate" v-else-if="message.type == MessageTypes.Location">
        <i class="bi bi-geo-alt me-2"></i>
        {{ $t("location") }}
      </div>
      <div class="paymentMessage text-truncate" v-else-if="message?.type == MessageTypes.Interactive">
        <p class="m-0">{{ getInteractiveMessageProps(message)?.text ?? $t('Not Supported Message Title') }}</p>
      </div>
      <div class="campaignMessage text-truncate" v-else-if="message?.type === MessageTypes.Template">
        <p class="m-0"><i class="icon bi bi-megaphone-fill"></i> <span>{{ message?.extra_data?.campaign?.name }}</span></p>
      </div>
      <div class="paymentMessage text-truncate" v-else>
        {{ $t('Not Supported Message Title') }}
      </div>
    </div>
    <div class="replyActions">
      <img v-if="message.type == MessageTypes.Image" :src="message.content.image.url" width="40" height="40">
      <button class="btn" @click="clearReplyToMessage">
        <img height="24" width="24" :src="loadFile(images.close)">
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { MessageTypes, PaymentStatuses, InteractiveSubtypes } from '@/components/whatsapp-managment/interfaces.js'
import { loadFile, getInteractiveMessageProps } from '@/components/utils.js'

const store = useStore();

const images = {
  close: 'close.svg',
  camera: 'camera.svg',
  cart: 'cart.svg',
  microphone: 'microphone.svg',
}

const message = computed(() => store.state.Chat.replyToMessage);

const clearReplyToMessage = () => {
  store.commit('Chat/setReplyToMessage', null);
}

</script>

<style scoped lang="scss">
@import './styles/index.scss';
</style>
